import React, { useMemo } from 'react';
import { IFormulaItemData } from '~/pages/FinancialModel/ModelBuilderContext';
import useFormulaContext from '~/pages/FinancialModel/useFormulaContext';
import { IFormattingEnum } from '~/services/parallel/formulas.types';
import formatCurrency from '~/utils/formatCurrency';
import numberWithCommas from '~/utils/numberWithCommas';

const MonthCell = ({
  columnWidth,
  data,
  columnIndex,
}: {
  columnWidth: number;
  data: IFormulaItemData;
  columnIndex: number;
}): React.ReactElement => {
  const { selectedMonths } = useFormulaContext();
  const LEADING_COLUMN_COUNT = 2;
  const month = selectedMonths[columnIndex - LEADING_COLUMN_COUNT];
  const monthlyValue = month in data.monthlyValues ? data.monthlyValues[month] : null;

  const formattedValue = useMemo(() => {
    if (!monthlyValue) return null;

    let numToFormat = Number(monthlyValue.calculatedValue);

    if (monthlyValue.actualValue !== null || monthlyValue.overrideValue !== null) {
      numToFormat = numToFormat * 100;
    }

    switch (monthlyValue.formatting) {
      case IFormattingEnum.Percent:
        return `${parseFloat(numToFormat.toFixed(2)).toString()}%`;
      case IFormattingEnum.Currency: {
        const val = (numToFormat / 100).toFixed(2);
        return formatCurrency(Number(val) * 100, monthlyValue.roundingInstructions ? false : true);
      }
      default:
        return numberWithCommas(Number(numToFormat / 100));
    }
  }, [monthlyValue]);

  if (!monthlyValue) return <div>Error</div>;

  const showYearDivider = month.includes('Dec');

  return (
    <div
      className={`bg-white h-[48px] px-3 py-2 flex items-center justify-end${showYearDivider ? ' border-r border-neutral-50' : ''}`}
      style={{ minWidth: `${columnWidth}px` }}
    >
      {formattedValue}
    </div>
  );
};

export default MonthCell;
